import Vue from 'vue';
import Router from 'vue-router';
import Regulation from './views/Regulation.vue';

Vue.use(Router);

/**
 * The supported languages, prevent routing to other targets.
 */
const languages = ['bg', 'cs', 'da', 'de', 'el',
    'en', 'es', 'fi', 'fr', 'ga', 'hr', 'hu', 'it',
    'lv', 'mt', 'nl', 'pl', 'pt', 'ro', 'sk', 'sl', 'sv' ];

/**
 * The router config with interactive (browse) mode and browse mode.
 */
const router = new Router({
  routes: [
   {
      path: '/',
    },
    {
      path: '/browse',
      name: 'browse',
      component: Regulation,
      props: (route) => ({
        lang: Array.isArray(route.query.lang) ? route.query.lang[0] : route.query.lang,
        chapter: +route.query.chapter,
        article: +route.query.article,
        interactive: true,
      }),
    },
    {
      path: '/expand',
      name: 'expand',
      component: Regulation,
      props: (route) => ({
        lang: Array.isArray(route.query.lang) ? route.query.lang[0] : route.query.lang,
        chapter: +route.query.chapter,
        article: +route.query.article,
        interactive: false,
      }),
    },
  ],
});

export default router;

router.beforeEach((to, from, next) => {
  let lang: string|null = null;
  if (to.query !== undefined && to.query.lang !== undefined) {
    lang = Array.isArray(to.query.lang) ? to.query.lang[0] : to.query.lang;
  }
  if (lang !== null) {
    if (languages.includes(lang)) {
      next();
    } else {
      next(false);
    }
  } else if (router.app.$root.$props !== undefined && router.app.$root.$props.lang !== undefined) {
    to.query.lang = router.app.$root.$props.lang;
    next();
  } else {
    next();
  }

});
